import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import Navbar from '../Navbar/NavBar';
import FiltersGamesPage from './FiltersGamesPage';
import TableGames from './TableGames';
import { useUserState } from '../../store/hooks';

export default () => {
  
  const user = useUserState();
  
  return (
    <>
      <Navbar />
      <Container className="container-00 gg-01">
        <h4 className="h-t">Games</h4>
        <Row>
          <Col lg={12} xs={12}>
            <FiltersGamesPage user={user} />
            <div className="games-body games-body-width">
              <TableGames />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
